// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AccountIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AccountIcon" ref={forwardedRef} {...props}>
      <path d="M13.996 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0m-4-2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5" />
      <path d="M5.504 13v3.5H5.502V18H4.004v-5.5a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1V18h-1.498v-1.5H14.5V13z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AccountIcon = /* @__PURE__ */ Object.assign(AccountIconComponent, {
  displayName: 'AccountIcon',
});
